function MasterCard({ className }: { className?: string }): JSX.Element {
  return (
    <svg
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect width="36" height="24" fill="#1E1E1E" />
      <path
        d="M-5582 -2731C-5582 -2732.1 -5581.1 -2733 -5580 -2733H24566C24567.1 -2733 24568 -2732.1 24568 -2731V8605C24568 8606.1 24567.1 8607 24566 8607H-5580C-5581.1 8607 -5582 8606.1 -5582 8605V-2731Z"
        fill="#444444"
      />
      <path
        d="M-5580 -2732H24566V-2734H-5580V-2732ZM24567 -2731V8605H24569V-2731H24567ZM24566 8606H-5580V8608H24566V8606ZM-5581 8605V-2731H-5583V8605H-5581ZM-5580 8606C-5580.55 8606 -5581 8605.55 -5581 8605H-5583C-5583 8606.66 -5581.66 8608 -5580 8608V8606ZM24567 8605C24567 8605.55 24566.6 8606 24566 8606V8608C24567.7 8608 24569 8606.66 24569 8605H24567ZM24566 -2732C24566.6 -2732 24567 -2731.55 24567 -2731H24569C24569 -2732.66 24567.7 -2734 24566 -2734V-2732ZM-5580 -2734C-5581.66 -2734 -5583 -2732.66 -5583 -2731H-5581C-5581 -2731.55 -5580.55 -2732 -5580 -2732V-2734Z"
        fill="white"
        fillOpacity="0.1"
      />
      <g clipPath="url(#clip0_17652_9447)">
        <rect
          width="1440"
          height="1030"
          transform="translate(-1249 -869)"
          fill="#F5F5F5"
        />
        <mask id="path-3-inside-1_17652_9447" fill="white">
          <path d="M-1094 -70H36V44H-1094V-70Z" />
        </mask>
        <path
          d="M-1094 -69H36V-71H-1094V-69Z"
          fill="#E0E0E0"
          mask="url(#path-3-inside-1_17652_9447)"
        />
        <g opacity="0.5">
          <path
            d="M33 0H3C1.34315 0 0 1.34315 0 3V21C0 22.6569 1.34315 24 3 24H33C34.6569 24 36 22.6569 36 21V3C36 1.34315 34.6569 0 33 0Z"
            fill="#252525"
          />
          <path
            d="M13.5 19.5C17.6421 19.5 21 16.1421 21 12C21 7.85786 17.6421 4.5 13.5 4.5C9.35786 4.5 6 7.85786 6 12C6 16.1421 9.35786 19.5 13.5 19.5Z"
            fill="#EB001B"
          />
          <path
            d="M22.5 19.5C26.6421 19.5 30 16.1421 30 12C30 7.85786 26.6421 4.5 22.5 4.5C18.3579 4.5 15 7.85786 15 12C15 16.1421 18.3579 19.5 22.5 19.5Z"
            fill="#F79E1B"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18 6C19.8217 7.36831 21 9.54682 21 12.0005C21 14.4543 19.8217 16.6328 18 18.0011C16.1783 16.6328 15 14.4543 15 12.0005C15 9.54682 16.1783 7.36831 18 6Z"
            fill="#FF5F00"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_17652_9447">
          <rect
            width="1440"
            height="1030"
            fill="white"
            transform="translate(-1249 -869)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default MasterCard;
